"use client"

import HeroBackground from "./HeroBackground"
import HeroCtaRow from "./HeroCtaRow"
import HeroPriceBlock from "./HeroPriceBlock"
import HeroSlideContent from "./HeroSlideContent"
import { HeroBottomRow, HeroSlideColumn, HeroSlideInner } from "./hero.styled"
import { HeroSlideProps } from "./types"

const HeroSlide = ({
  slide,
  shouldPlayVideo,
  reducedMotion,
  index,
  total,
  isActive,
  canAdvance,
  onVideoEnded,
  onVideoDuration,
}: HeroSlideProps) => {
  const inertProp = !isActive
    ? ({ inert: true } as Record<string, unknown>)
    : {}
  const showPriceBlock =
    !!slide.price || !!slide.priceLabel || !!slide.priceNote
  return (
    <HeroSlideInner
      role="group"
      aria-roledescription="slide"
      aria-label={`${index + 1} מתוך ${total}`}
      aria-hidden={!isActive || undefined}
      {...inertProp}
    >
      <HeroBackground
        slide={slide}
        isActive={isActive}
        shouldPlayVideo={shouldPlayVideo}
        reducedMotion={reducedMotion}
        canAdvance={canAdvance}
        onVideoEnded={onVideoEnded}
        onVideoDuration={onVideoDuration}
      />
      <HeroSlideColumn>
        <HeroSlideContent slide={slide} />
        <HeroBottomRow>
          {/* RTL: first child renders on the right. CTA row right, price block left (matches Figma). */}
          <HeroCtaRow slide={slide} />
          {showPriceBlock && <HeroPriceBlock slide={slide} />}
        </HeroBottomRow>
      </HeroSlideColumn>
    </HeroSlideInner>
  )
}

export default HeroSlide
